import {
  PUT_LEAD,
  PUT_LEAD_ERROR,
  CLEAN_PUT_LEAD,
  CLEAN_PUT_LEAD_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function putLeadReducer(state = initialState, action) {
  switch (action.type) {
    case PUT_LEAD:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case PUT_LEAD_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_PUT_LEAD:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_PUT_LEAD_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
